import { useContext } from "react";
import { FaSignOutAlt } from "react-icons/fa";
import { FiAlertCircle, FiCalendar, FiClock, FiCreditCard, FiFileText, FiSettings, FiShield, FiHome, FiLock } from "react-icons/fi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../../../context/AppContext";
import "../../../assets/css/doctor/doctorsidebar/DoctorSidebar.css";

const SpeechBubbleLogo = () => (
  <svg width="38" height="38" viewBox="0 0 100 100" className="doc-logo-svg">
    <circle cx="50" cy="50" r="48" fill="#00005a" />
    <circle cx="50" cy="48" r="32" fill="#FF6F00" />
    <circle cx="50" cy="48" r="22" fill="#FFFFFF" />
    <path d="M 38 70 L 30 82 L 48 74 Z" fill="#FF6F00" />
  </svg>
);

const DoctorSidebar = ({ isOpen = true, onNavigate }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { kycStatus, therapistLogout } = useContext(AppContext);

  const isApproved = kycStatus === "approved";

  const menuItems = [
    { name: "Dashboard", path: "/doctor", icon: <FiHome />, alwaysUnlocked: true },
    { name: "Kyc", path: "/doctor/Kyc", icon: <FiShield />, alwaysUnlocked: true },
    { name: "Appointments", path: "/doctor/appointments", icon: <FiCalendar /> },
    { name: "Schedule", path: "/doctor/schedulemanagement", icon: <FiCalendar /> },
    { name: "Wallet", path: "/doctor/wallet", icon: <FiCreditCard /> },
    { name: "History", path: "/doctor/history", icon: <FiClock /> },
    { name: "Prescriptions", path: "/doctor/prescriptions", icon: <FiFileText /> },
    { name: "Disputes", path: "/doctor/dispute", icon: <FiAlertCircle /> },
    { name: "Settings", path: "/doctor/settings", icon: <FiSettings />, alwaysUnlocked: true },
  ];

  const handleLockedClick = (e) => {
    e.preventDefault();
    alert("Please complete your KYC verification first to access this section.");
  };

  const handleLogout = () => {
    therapistLogout();
    navigate("/");
  };

  return (
    <aside className={`doc-sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="doc-sidebar-header">
        <Link to="/" className="doc-logo-container">
          <SpeechBubbleLogo />
          <span className="doc-logo-text">
            Smart<span className="doc-logo-highlight">Therapy</span>
          </span>
        </Link>
      </div>

      <nav className="doc-sidebar-nav">
        {menuItems.map((item) => {
          const isLocked = !item.alwaysUnlocked && !isApproved;
          const isActive = location.pathname === item.path;

          return (
            <div key={item.path} className="doc-nav-item-wrapper">
              {isLocked ? (
                <a
                  href={item.path}
                  onClick={handleLockedClick}
                  className="doc-nav-item doc-locked"
                >
                  <span className="doc-nav-icon">{item.icon}</span>
                  <span className="doc-nav-text">{item.name}</span>
                  <FiLock size={14} className="doc-lock-icon" />
                </a>
              ) : (
                <Link
                  to={item.path}
                  onClick={onNavigate}
                  className={`doc-nav-item ${isActive ? "active" : ""}`}
                >
                  <span className="doc-nav-icon">{item.icon}</span>
                  <span className="doc-nav-text">{item.name}</span>
                </Link>
              )}
            </div>
          );
        })}
      </nav>

      <div className="doc-sidebar-footer">
        <button type="button" className="doc-logout-btn" onClick={handleLogout} title="Logout">
          <FaSignOutAlt />
          <span className="doc-logout-text">Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default DoctorSidebar;